(function () {
    const $banner = $('#cookie-banner'),
        $settings = $('#cookie-settings'),
        cookieName = 'CookieConsent';

    const blockedCookies = {
        preferences: ['_locale'],
        statistics: [],
        marketing: ['_ga', '_ga_#']
    };

    function setCookie(name, value, days = 365) {
        const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
        document.cookie = `${name}=${value}; expires=${expires}; path=/; SameSite=Lax`;
    }

    function getCookie(name) {
        const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        return match ? match[2] : null;
    }

    function deleteCookie(name) {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${location.pathname};`;
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${location.hostname};`;
    }

    function blockCookies(consent) {
        $.each(blockedCookies, function (category, cookies) {
            if (!consent[category]) {
                cookies.forEach(function (name) {
                    if (name instanceof RegExp) {
                        document.cookie.split(';').forEach(function (c) {
                            const cookieName = c.split('=')[0].trim();
                            if (name.test(cookieName)) deleteCookie(cookieName);
                        });
                    } else {
                        deleteCookie(name);
                    }
                });
            }
        });
    }

    const savedConsent = getCookie(cookieName);
    if (!savedConsent) {
        $banner.show();
    } else {
        try {
            applyConsent(JSON.parse(savedConsent));
        } catch (e) {
            deleteCookie(cookieName);
            $banner.show();
        }
    }

    $('.accept-all').on('click', function () {
        const consent = {necessary: true, preferences: true, statistics: true, marketing: true};
        setCookie(cookieName, JSON.stringify(consent));
        $settings.find('input[type="checkbox"]').each(function () {
            $(this).attr('checked', true).prop('checked', true);
        });
        applyConsent(consent, 300);
    });

    $('.accept-chosen').on('click', function () {
        const consent = {necessary: true};
        $settings.find('input[type="checkbox"]').each(function () {
            consent[$(this).data('cookie')] = $(this).is(':checked');
        });
        setCookie(cookieName, JSON.stringify(consent));
        applyConsent(consent);
    });

    function applyConsent(consent, timeout = 0) {
        blockCookies(consent);
        if ($banner.length) {
            setTimeout(() => {
                $banner.slideUp();
            }, timeout);
        }
    }
})();
